import React from 'react';
import Aurora from '../components/Aurora';
import './UnderReviewPage.css';

const UnderReviewPage: React.FC = () => {
  return (
    <div className="under-review-page">
      <div className="aurora-background">
        <Aurora
          colorStops={["#7d19ff", "#a560ff", "#801eff"]}
          blend={0.5}
          amplitude={1.0}
          speed={0.5}
        />
      </div>
      <div className="under-review-container">
        <div className="logo-section">
        </div>
        
        <div className="review-content">
          <h2 className="review-title">Account Under Review</h2>
          
          <p className="review-description">
            Your SolBlox account is currently under review by our moderators.
          </p>
          
          <p className="review-info">
            This process typically takes 24-48 hours. You'll be notified once the review is complete.
          </p>
          
          <a 
            href="https://discord.gg/solblox" 
            target="_blank" 
            rel="noopener noreferrer"
            className="discord-btn"
          >
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default UnderReviewPage;
